import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { NavigationService } from 'app/services/navigation-service';

interface Step {
    step: OrderStep;
    path: string;
}

class OrderStepService {
    public static readonly ORDER_STEPS: Step[] = [
        {
            step: OrderStep.CHOOSE_ACCOUNT,
            path: NavigationService.CHOOSE_ACCOUNT,
        },
        {
            step: OrderStep.CHOOSE_SERVICE_LOCATION,
            path: NavigationService.CHOOSE_SERVICE_LOCATION,
        },
        {
            step: OrderStep.HOUSING_SELECT,
            path: NavigationService.HOUSING_SELECT,
        },
        {
            step: OrderStep.PRODUCTS_DETAILS,
            path: NavigationService.PRODUCT_DETAILS,
        },
        {
            step: OrderStep.SUMMARY,
            path: NavigationService.SUMMARY,
        },
        {
            step: OrderStep.SUCCESS,
            path: NavigationService.SUCCESS,
        },
    ];

    public static readonly canAccessStep = (step: OrderStep, reachedStep: OrderStep): boolean => {
        const stepIndex: number = OrderStepService.getStepIndex(step);
        const reachedStepIndex: number = OrderStepService.getStepIndex(reachedStep);

        return stepIndex <= reachedStepIndex;
    };

    public static readonly getStepIndex = (step: OrderStep): number =>
        OrderStepService.ORDER_STEPS.findIndex((orderStep) => orderStep.step === step);

    public static readonly getStepPath = (step: OrderStep): string =>
        OrderStepService.ORDER_STEPS.find((_step) => _step.step === step)?.path ||
        (() => {
            throw new Error(`Order step ${step} not found.`);
        })();
}

export { OrderStepService };
